/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
//window.themeVariables.settings.staggerMenuApparition = false;
//const noStagger = () => 0;
 document.addEventListener('DOMContentLoaded', function() {

  console.log('Auto Load More initialized');

  let isLoading = false;

  function getElements() {
    const list = document.querySelector('.boost-sd__product-list');
    const btn = document.querySelector('.boost-sd__pagination-load-more-container-item .boost-sd__pagination-button');
    const container = document.querySelector('.boost-sd__pagination-load-more-container-item');

    if (!list || !btn || !container) return null;

    return { list, btn, container };
  }

  function getCounts(list) {
    const total = parseInt(list.dataset.totalProduct || 0, 10);

    // safer than custom class
    const loaded = list.children.length;

    return { total, loaded };
  }

  function handleAutoLoad() {
    const els = getElements();
    if (!els) return;

    const { list, btn, container } = els;

    const rect = container.getBoundingClientRect();

    // trigger before reaching bottom
    if (rect.top > window.innerHeight + 200) return;

    if (isLoading) return;

    const { total, loaded } = getCounts(list);

    // ✅ all loaded → hide button
    if (loaded >= total) {
      container.style.display = 'none';
      return;
    }

    // ✅ start loading
    isLoading = true;

    btn.classList.add('is-loading');    

    const beforeCount = loaded;

    btn.click();
    btn.disabled = true;

    // ✅ wait until new items appear (no timeout guessing)
    const check = setInterval(() => {
      const newEls = getElements();
      if (!newEls) return;

      const { loaded: newLoaded, total: newTotal } = getCounts(newEls.list);

      if (newLoaded > beforeCount) {
        btn.classList.remove('is-loading');
        btn.disabled = false;
        isLoading = false;

        // ✅ finished → hide
        if (newLoaded >= newTotal) {
          newEls.container.style.display = 'none';
        }

        clearInterval(check);
      }
    }, 300);
  }

  function init() {
    // prevent multiple bindings
    if (window.__autoLoadBound) return;
    window.__autoLoadBound = true;

    window.addEventListener('scroll', handleAutoLoad);
  }

  // 🔹 wait for Boost to render
  const wait = setInterval(() => {
    console.log('teste')
    const els = getElements();
    if (els) {
      init();
      clearInterval(wait);
    }
  }, 600);

  // 🔹 re-init after Boost DOM updates (filters, pagination, etc.)
  const observer = new MutationObserver(() => {
    window.__autoLoadBound = false;
    init();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

 
  var inverval2 = setInterval(() => {
    if(document.querySelector('.toolbar-sub-menu-wraper')){
      document.querySelectorAll('.toolbar-sub-menu-wraper a').forEach(item=>{
          if(item.getAttribute('href') == window.location.pathname){
            item.classList.add('active');
          }
          item.addEventListener('click', function(){window.location.href = this.getAttribute('href')})
      }) 
      clearInterval(inverval2)
    }
    
  }, 500);
  setInterval(function(){
    if(document.querySelector('#boost-sd__filter-tree-vertical--style-off-canvas') && document.querySelector('.boost-sd__filter-tree-vertical--hidden') == null){
      document.querySelector('.boost-sd__filter-tree-toggle-button--expand')?.classList.add('boost-sd__filter-tree-toggle-button--active');
    }
    if(document.querySelector('.toolbar-sub-menu-wraper')){
      document.querySelectorAll('.toolbar-sub-menu-wraper a').forEach(item=>{
        item.addEventListener('click', function(){window.location.href = this.getAttribute('href')})
      })
    }
  },300)
  
  document.body.addEventListener('click', function(e) {
    const el = e.target.closest('#boost-sd__filter-tree-vertical--style-off-canvas');
    const e2 = e.target.closest('#boost-sd_filter-tree-mobile');    
    const e4 = e.target.closest('button[aria-controls="sidebar-menu"]');
    const e5 = e.target.closest('.header__search-link .header-sidebar__linklist-button'); 
    const e6 = e.target.closest('.boost-sd__view-as--column .boost-sd__tooltip[data-id="1"]');
    const e7 = e.target.closest('.boost-sd__view-as--column .boost-sd__tooltip[data-id="2"]');
    const e8 = e.target.closest('.header__search-link.md-max\\:hidden');

    if(e6){
      document.body.setAttribute('data-pd-view','1');
    }
    if(e7){
      document.body.setAttribute('data-pd-view','2');
    }

    if(e5 || e8){
      document.querySelector("#predictive-search-form input").click();
      setTimeout(function(){
        document.body.click();
      },500)
    }

    if(e4){
      document.querySelectorAll('.header-sidebar__linklist .accordion__disclosure').forEach(item=>{
          item.setAttribute('open','');
      })
      document.querySelector('.header-sidebar__main-panel')?.setAttribute('data-state','open');      
      document.querySelector('.boost-sd__search-bar-wrapper--mobile .boost-sd__button-text-x--close-style1').click();
    }
   
    if (el || e2) {
      console.log('Clicked filter');
    }else if(document.body.classList.contains("boost-sd__g-no-scroll") && e.target.closest('.boost-sd__filter-tree-toggle-button') == null && e.target.closest('body').querySelector('.boost-sd__filter-tree-toggle-button--active')){      
      document.querySelector('.boost-sd__filter-tree-toggle-button')?.click();   
      setTimeout(function(){document.body.classList.remove("boost-sd__g-no-scroll");},200);   
    }else if(document.body.classList.contains("boost-sd__g-no-scroll") && e.target.closest('.boost-sd__filter-tree-toggle-button') == null && !e.target.closest('body').querySelector('#boost-sd_filter-tree-mobile[style*="display: none"]')){      
      document.querySelector('#boost-sd__filter-tree-toggle-button')?.click() 
      setTimeout(function(){document.body.classList.remove("boost-sd__g-no-scroll");},200);   
    }
  });
   if(localStorage.last_visit_time != undefined){
      if((Date.now() - localStorage.last_visit_time*1) > 2*24*60*60*1000){
        localStorage.last_visit_time = Date.now();
        localStorage.removeItem('used_filter')
      }
    }else{
      localStorage.last_visit_time = Date.now();
    }
   localStorage.scroll_deapth = 0;
    // Listen for scroll events
   function calculateScrollPercentage() {
      var scrollTop = window.scrollY; // Distance scrolled from the top
      var windowHeight = window.innerHeight; // Height of the viewport
      var fullHeight = document.body.scrollHeight; // Total scrollable height of the page
  
      var scrollPercentage = (scrollTop / (fullHeight - windowHeight)) * 100;      
      return scrollPercentage;
  }
    window.addEventListener('scroll', function() {    
      var scrollPercentage = calculateScrollPercentage(); 
      if(scrollPercentage > localStorage.scroll_deapth*1){  
        localStorage.scroll_deapth = scrollPercentage.toFixed(2);
        if(document.querySelector('[name="properties[_scroll_depth]"]')){
          document.querySelector('[name="properties[_scroll_depth]"]').value = localStorage.scroll_deapth + "%";
        }
        
      }
        
    });
   
    document.querySelector('#scroll-to-target')?.addEventListener('click',function(e){
        e.preventDefault();
        document.querySelector('#bundle-section')?.scrollIntoView({  behavior: "smooth"});
        document.querySelector('#collection-container')?.scrollIntoView({ behavior: "smooth"});
    })
    document.querySelector('[href="#scroll-to-target"]')?.addEventListener('click',function(e){
        e.preventDefault();
        document.querySelector('#bundle-section')?.scrollIntoView({  behavior: "smooth"});
        document.querySelector('#collection-container')?.scrollIntoView({ behavior: "smooth"});
    })
    document.querySelector('#scroll-to-target-replo')?.addEventListener('click',function(e){
        e.preventDefault();
        document.querySelector('#bundle_c_section')?.scrollIntoView({  behavior: "smooth"});
        document.querySelector('#collection-container')?.scrollIntoView({ behavior: "smooth"});
    })
  
    var refer_url = location.pathname.split('/').slice(-1)[0]?location.pathname.split('/').slice(-1)[0]:"home"
  
    document.querySelectorAll('a[href*="/collection"]:not([href^="#"]').forEach(item=>{
        let temp_href = item.getAttribute('href').indexOf('?')>0? item.getAttribute('href') + '&internal_referral=' +  refer_url:item.getAttribute('href') + '?internal_referral=' +  refer_url;
        item.setAttribute('href',temp_href);    
    })
    document.querySelectorAll('a[href*="product"]:not([href^="#"]').forEach(item=>{
        let temp_href = item.getAttribute('href').indexOf('?')>0? item.getAttribute('href') + '&internal_referral=' +  refer_url:item.getAttribute('href') + '?internal_referral=' +  refer_url;
        item.setAttribute('href',temp_href);  
    })
    document.querySelectorAll('[data-section-name]').forEach(item=>{
        var section_name = item.getAttribute('data-section-name');
        item.querySelectorAll('a[href]:not(a[href*="#"])').forEach(s_item=>{
          if(s_item.getAttribute('href').indexOf('?')>0){
            let temp_href = s_item.getAttribute('href') + '&section_clicked=' +  section_name;
            s_item.setAttribute('href',temp_href);  
          }else{
            let temp_href = s_item.getAttribute('href') + '?section_clicked=' +  section_name;
            s_item.setAttribute('href',temp_href);    
          }
        })
    })
   document.querySelectorAll('.j-filter-options').forEach((item)=>{
      item.addEventListener('click',function(){
          let option_val = item.getAttribute('data-type');
          if(localStorage.used_filter == undefined){
              localStorage.used_filter = option_val
          }else if(localStorage.used_filter.indexOf(option_val)<0){            
              localStorage.used_filter =localStorage.used_filter+ ', '+ option_val
          }
      })
    })
    const searchParams = new URLSearchParams(window.location.search);
    var utm_properties = '';
    searchParams.forEach((val,key)=>{
      switch(key){
        case "internal_referral":          
          if(document.querySelector('input[name="properties[_internal_referrer]"]') && document.querySelector('input[name="properties[_internal_referrer]"]').value == '' ){
            document.querySelector('input[name="properties[_internal_referrer]"]').value = val;
          }
          break;
        case "discount_card":          
          localStorage.discount_card = 'clicked';          
          break;
        case "utm_source":
          utm_properties += `<input type="hidden" name="properties[_utm_source]" value="${val}">`;          
          break;
        case "utm_medium":
          utm_properties += `<input type="hidden" name="properties[_utm_medium]" value="${val}">`;          
          break;
        case "utm_campaign":
          utm_properties += `<input type="hidden" name="properties[_utm_campaign]" value="${val}">`;          
          break;
        case "utm_term":
          utm_properties += `<input type="hidden" name="properties[_utm_term]" value="${val}">`;          
          break;
        case "utm_content":
          utm_properties += `<input type="hidden" name="properties[_utm_content]" value="${val}">`;          
          break;
        case "campaign_id":
          utm_properties += `<input type="hidden" name="properties[_campaign_id]" value="${val}">`; 
          break;
        case "ad_id":
          utm_properties += `<input type="hidden" name="properties[_ad_id]" value="${val}">`; 
          break;
        case "section_clicked":
          utm_properties += `<input type="hidden" name="properties[_section_clicked]" value="${val}">`; 
          break;
        case "section_source":
          utm_properties += `<input type="hidden" name="properties[_section_source]" value="${val}">`; 
          break;
        case "_ab_croboost":
          utm_properties += `<input type="hidden" name="properties[_ab_croboost]" value="${val}">`; 
          break;
      }              
        
    })
   utm_properties += `<input type="hidden" name="properties[_scroll_depth]" value="0%">`; 
   if(localStorage.discount_card == 'clicked'){
      utm_properties += `<input type="hidden" name="properties[_discount_card]" value="clicked">`; 
    }     
   if(localStorage.used_filter != undefined){
     utm_properties += `<input type="hidden" name="properties[_used_filters]" value="${localStorage.used_filter}">`; 
   }
    document.querySelectorAll('.utm_properties').forEach(item=>{
      item.innerHTML = utm_properties;
    })
  /*
    document.querySelectorAll('.quick-add-wraper-js .variant-options li:not(.sold-out)').forEach(item=>{
      item.addEventListener('click', () => {
        let items = [];
        // animation for submitting
        this.closest('.quick-add-wraper-js')?.setAttribute('aria-busy',true);    
        if(this.getAttribute('pre_order')){
          items.push(
          { 
            quantity: 1, 
            id: this.getAttribute('value'), 
            properties: {                
              '_source': "collection",
              '_sourceurl': window.location.pathname,
              '_internal_referrer':location.search.split('internal_referral=')[1],            
              'pre': 'order',
              '_add_type': 'quick_add'
            } 
          });
        }else{
          items.push(
          { 
            quantity: 1, 
            id: this.getAttribute('value'), 
            properties: {                
              '_source': "collection",
              '_sourceurl': window.location.pathname, 
              '_internal_referrer':location.search.split('internal_referral=')[1],
              '_add_type': 'quick_add'
            } 
          });
        }
        
          
      
        // fire event add items to cart
        addQuickItems(items);
      
        // get fresh cart details
        async function getCart() {
          const result = await fetch("/cart.json");
          const res = await result.json();
          return res;
        }
      
        function addQuickItems(items) {
          fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ items: items }),
          }).then((v) => {
      
            // success
            document.querySelector('.quick-add-wraper-js[aria-busy]')?.removeAttribute('aria-busy');
            console.log('aa');
            getCart().then(v => {
                // document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
                //   bubbles: true,
                //   detail: {
                //     cart: v
                //   }
                // }));
                // document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {	
                //     bubbles: false,	
                //     detail: {}	
                // }));
                // document.querySelector('a[aria-controls="mini-cart"]').click();
              });
          });
        }
      })
    })*/
})
  
  function Delegate(root) {
    this.listenerMap = [{}, {}];
    if (root) {
      this.root(root);
    }
    this.handle = Delegate.prototype.handle.bind(this);
    this._removedListeners = [];
  }
  Delegate.prototype.root = function(root) {
    const listenerMap = this.listenerMap;
    let eventType;
    if (this.rootElement) {
      for (eventType in listenerMap[1]) {
        if (listenerMap[1].hasOwnProperty(eventType)) {
          this.rootElement.removeEventListener(eventType, this.handle, true);
        }
      }
      for (eventType in listenerMap[0]) {
        if (listenerMap[0].hasOwnProperty(eventType)) {
          this.rootElement.removeEventListener(eventType, this.handle, false);
        }
      }
    }
    if (!root || !root.addEventListener) {
      if (this.rootElement) {
        delete this.rootElement;
      }
      return this;
    }
    this.rootElement = root;
    for (eventType in listenerMap[1]) {
      if (listenerMap[1].hasOwnProperty(eventType)) {
        this.rootElement.addEventListener(eventType, this.handle, true);
      }
    }
    for (eventType in listenerMap[0]) {
      if (listenerMap[0].hasOwnProperty(eventType)) {
        this.rootElement.addEventListener(eventType, this.handle, false);
      }
    }
    return this;
  };
  Delegate.prototype.captureForType = function(eventType) {
    return ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(eventType) !== -1;
  };
  Delegate.prototype.on = function(eventType, selector, handler, useCapture) {
    let root;
    let listenerMap;
    let matcher;
    let matcherParam;
    if (!eventType) {
      throw new TypeError("Invalid event type: " + eventType);
    }
    if (typeof selector === "function") {
      useCapture = handler;
      handler = selector;
      selector = null;
    }
    if (useCapture === void 0) {
      useCapture = this.captureForType(eventType);
    }
    if (typeof handler !== "function") {
      throw new TypeError("Handler must be a type of Function");
    }
    root = this.rootElement;
    listenerMap = this.listenerMap[useCapture ? 1 : 0];
    if (!listenerMap[eventType]) {
      if (root) {
        root.addEventListener(eventType, this.handle, useCapture);
      }
      listenerMap[eventType] = [];
    }
    if (!selector) {
      matcherParam = null;
      matcher = matchesRoot.bind(this);
    } else if (/^[a-z]+$/i.test(selector)) {
      matcherParam = selector;
      matcher = matchesTag;
    } else if (/^#[a-z0-9\-_]+$/i.test(selector)) {
      matcherParam = selector.slice(1);
      matcher = matchesId;
    } else {
      matcherParam = selector;
      matcher = Element.prototype.matches;
    }
    listenerMap[eventType].push({
      selector,
      handler,
      matcher,
      matcherParam
    });
    return this;
  };
  Delegate.prototype.off = function(eventType, selector, handler, useCapture) {
    let i;
    let listener;
    let listenerMap;
    let listenerList;
    let singleEventType;
    if (typeof selector === "function") {
      useCapture = handler;
      handler = selector;
      selector = null;
    }
    if (useCapture === void 0) {
      this.off(eventType, selector, handler, true);
      this.off(eventType, selector, handler, false);
      return this;
    }
    listenerMap = this.listenerMap[useCapture ? 1 : 0];
    if (!eventType) {
      for (singleEventType in listenerMap) {
        if (listenerMap.hasOwnProperty(singleEventType)) {
          this.off(singleEventType, selector, handler);
        }
      }
      return this;
    }
    listenerList = listenerMap[eventType];
    if (!listenerList || !listenerList.length) {
      return this;
    }
    for (i = listenerList.length - 1; i >= 0; i--) {
      listener = listenerList[i];
      if ((!selector || selector === listener.selector) && (!handler || handler === listener.handler)) {
        this._removedListeners.push(listener);
        listenerList.splice(i, 1);
      }
    }
    if (!listenerList.length) {
      delete listenerMap[eventType];
      if (this.rootElement) {
        this.rootElement.removeEventListener(eventType, this.handle, useCapture);
      }
    }
    return this;
  };
  Delegate.prototype.handle = function(event) {
    let i;
    let l;
    const type = event.type;
    let root;
    let phase;
    let listener;
    let returned;
    let listenerList = [];
    let target;
    const eventIgnore = "ftLabsDelegateIgnore";
    if (event[eventIgnore] === true) {
      return;
    }
    target = event.target;
    if (target.nodeType === 3) {
      target = target.parentNode;
    }
    if (target.correspondingUseElement) {
      target = target.correspondingUseElement;
    }
    root = this.rootElement;
    phase = event.eventPhase || (event.target !== event.currentTarget ? 3 : 2);
    switch (phase) {
      case 1:
        listenerList = this.listenerMap[1][type];
        break;
      case 2:
        if (this.listenerMap[0] && this.listenerMap[0][type]) {
          listenerList = listenerList.concat(this.listenerMap[0][type]);
        }
        if (this.listenerMap[1] && this.listenerMap[1][type]) {
          listenerList = listenerList.concat(this.listenerMap[1][type]);
        }
        break;
      case 3:
        listenerList = this.listenerMap[0][type];
        break;
    }
    let toFire = [];
    l = listenerList.length;
    while (target && l) {
      for (i = 0; i < l; i++) {
        listener = listenerList[i];
        if (!listener) {
          break;
        }
        if (target.tagName && ["button", "input", "select", "textarea"].indexOf(target.tagName.toLowerCase()) > -1 && target.hasAttribute("disabled")) {
          toFire = [];
        } else if (listener.matcher.call(target, listener.matcherParam, target)) {
          toFire.push([event, target, listener]);
        }
      }
      if (target === root) {
        break;
      }
      l = listenerList.length;
      target = target.parentElement || target.parentNode;
      if (target instanceof HTMLDocument) {
        break;
      }
    }
    let ret;
    for (i = 0; i < toFire.length; i++) {
      if (this._removedListeners.indexOf(toFire[i][2]) > -1) {
        continue;
      }
      returned = this.fire.apply(this, toFire[i]);
      if (returned === false) {
        toFire[i][0][eventIgnore] = true;
        toFire[i][0].preventDefault();
        ret = false;
        break;
      }
    }
    return ret;
  };
  Delegate.prototype.fire = function(event, target, listener) {
    return listener.handler.call(target, event, target);
  };
  function matchesTag(tagName, element) {
    return tagName.toLowerCase() === element.tagName.toLowerCase();
  }
  function matchesRoot(selector, element) {
    if (this.rootElement === window) {
      return element === document || element === document.documentElement || element === window;
    }
    return this.rootElement === element;
  }
  function matchesId(id, element) {
    return id === element.id;
  }
  Delegate.prototype.destroy = function() {
    this.off();
    this.root();
  };
  Delegate.prototype.destroy = function() {
    this.off();
    this.root();
  };
  var main_default = Delegate;

  // js/components/input-binding-manager.js
  var InputBindingManager = class {
    constructor() {
      this.delegateElement = new main_default(document.body);
      this.delegateElement.on("change", "[data-bind-value]", this._onValueChanged.bind(this));
    }
    _onValueChanged(event, target) {
      const boundElement = document.getElementById(target.getAttribute("data-bind-value"));
      if (boundElement) {
        if (target.tagName === "SELECT") {
          target = target.options[target.selectedIndex];
        }
        boundElement.innerHTML = target.hasAttribute("title") ? target.getAttribute("title") : target.value;
      }
    }
  };

  // js/helper/event.js
  function triggerEvent(element, name, data = {}) {
    element.dispatchEvent(new CustomEvent(name, {
      bubbles: true,
      detail: data
    }));
  }
  function triggerNonBubblingEvent(element, name, data = {}) {
    element.dispatchEvent(new CustomEvent(name, {
      bubbles: false,
      detail: data
    }));
  }

  // js/custom-element/custom-html-element.js
  var CustomHTMLElement = class extends HTMLElement {
    constructor() {
      super();
      this._hasSectionReloaded = false;
      if (Shopify.designMode) {
        this.rootDelegate.on("shopify:section:select", (event) => {
          const parentSection = this.closest(".shopify-section");
          if (event.target === parentSection && event.detail.load) {
            this._hasSectionReloaded = true;
          }
        });
      }
    }
    get rootDelegate() {
      return this._rootDelegate = this._rootDelegate || new main_default(document.documentElement);
    }
    get delegate() {
      return this._delegate = this._delegate || new main_default(this);
    }
    showLoadingBar() {
      triggerEvent(document.documentElement, "theme:loading:start");
    }
    hideLoadingBar() {
      triggerEvent(document.documentElement, "theme:loading:end");
    }
    untilVisible(intersectionObserverOptions = { rootMargin: "0px", threshold: 0.2 }) {
      const onBecameVisible = () => {
        this.classList.add("became-visible");
        this.style.opacity = "1";
      };
      return new Promise((resolve) => {
        if (window.IntersectionObserver) {
          this.intersectionObserver = new IntersectionObserver((event) => {
            if (event[0].isIntersecting) {
              this.intersectionObserver.disconnect();
              requestAnimationFrame(() => {
                resolve();
                onBecameVisible();
              });
            }
          }, intersectionObserverOptions);
          this.intersectionObserver.observe(this);
        } else {
          resolve();
          onBecameVisible();
        }
      });
    }
    disconnectedCallback() {
      var _a;
      this.delegate.destroy();
      this.rootDelegate.destroy();
      (_a = this.intersectionObserver) == null ? void 0 : _a.disconnect();
      delete this._delegate;
      delete this._rootDelegate;
    }
  };

  // node_modules/tabbable/dist/index.esm.js
  var candidateSelectors = ["input", "select", "textarea", "a[href]", "button", "[tabindex]", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])', "details>summary:first-of-type", "details"];
  var candidateSelector = /* @__PURE__ */ candidateSelectors.join(",");
  var matches = typeof Element === "undefined" ? function() {
  } : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
  var getCandidates = function getCandidates2(el, includeContainer, filter) {
    var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector));
    if (includeContainer && matches.call(el, candidateSelector)) {
      candidates.unshift(el);
    }
    candidates = candidates.filter(filter);
    return candidates;
  };
  var isContentEditable = function isContentEditable2(node) {
    return node.contentEditable === "true";
  };
  var getTabindex = function getTabindex2(node) {
    var tabindexAttr = parseInt(node.getAttribute("tabindex"), 10);
    if (!isNaN(tabindexAttr)) {
      return tabindexAttr;
    }
    if (isContentEditable(node)) {
      return 0;
    }
    if ((node.nodeName === "AUDIO" || node.nodeName === "VIDEO" || node.nodeName === "DETAILS") && node.getAttribute("tabindex") === null) {
      return 0;
    }
    return node.tabIndex;
  };
  var sortOrderedTabbables = function sortOrderedTabbables2(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
  };
  var isInput = function isInput2(node) {
    return node.tagName === "INPUT";
  };
  var isHiddenInput = function isHiddenInput2(node) {
    return isInput(node) && node.type === "hidden";
  };
  var isDetailsWithSummary = function isDetailsWithSummary2(node) {
    var r = node.tagName === "DETAILS" && Array.prototype.slice.apply(node.children).some(function(child) {
      return child.tagName === "SUMMARY";
    });
    return r;
  };
  var getCheckedRadio = function getCheckedRadio2(nodes, form) {
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].checked && nodes[i].form === form) {
        return nodes[i];
      }
    }
  };
  var isTabbableRadio = function isTabbableRadio2(node) {
    if (!node.name) {
      return true;
    }
    var radioScope = node.form || node.ownerDocument;
    var queryRadios = function queryRadios2(name) {
      return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
    };
    var radioSet;
    if (typeof window !== "undefined" && typeof window.CSS !== "undefined" && typeof window.CSS.escape === "function") {
      radioSet = queryRadios(window.CSS.escape(node.name));
    } else {
      try {
        radioSet = queryRadios(node.name);
      } catch (err) {
        console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", err.message);
        return false;
      }
    }
    var checked = getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
  };
  var isRadio = function isRadio2(node) {
    return isInput(node) && node.type === "radio";
  };
  var isNonTabbableRadio = function isNonTabbableRadio2(node) {
    return isRadio(node) && !isTabbableRadio(node);
  };
  var isHidden = function isHidden2(node, displayCheck) {
    if (getComputedStyle(node).visibility === "hidden") {
      return true;
    }
    var isDirectSummary = matches.call(node, "details>summary:first-of-type");
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
    if (matches.call(nodeUnderDetails, "details:not([open]) *")) {
      return true;
    }
    if (!displayCheck || displayCheck === "full") {
      while (node) {
        if (getComputedStyle(node).display === "none") {
          return true;
        }
        node = node.parentElement;
      }
    } else if (displayCheck === "non-zero-area") {
      var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
      return width === 0 && height === 0;
    }
    return false;
  };
  var isDisabledFromFieldset = function isDisabledFromFieldset2(node) {
    if (isInput(node) || node.tagName === "SELECT" || node.tagName === "TEXTAREA" || node.tagName === "BUTTON") {
      var parentNode = node.parentElement;
      while (parentNode) {
        if (parentNode.tagName === "FIELDSET" && parentNode.disabled) {
          for (var i = 0; i < parentNode.children.length; i++) {
            var child = parentNode.children.item(i);
            if (child.tagName === "LEGEND") {
              if (child.contains(node)) {
                return false;
              }
              return true;
            }
          }
          return true;
        }
        parentNode = parentNode.parentElement;
      }
    }
    return false;
  };
  var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable2(options, node) {
    if (node.disabled || isHiddenInput(node) || isHidden(node, options.displayCheck) || isDetailsWithSummary(node) || isDisabledFromFieldset(node)) {
      return false;
    }
    return true;
  };
  var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable2(options, node) {
    if (!isNodeMatchingSelectorFocusable(options, node) || isNonTabbableRadio(node) || getTabindex(node) < 0) {
      return false;
    }
    return true;
  };
  var tabbable = function tabbable2(el, options) {
    options = options || {};
    var regularTabbables = [];
    var orderedTabbables = [];
    var candidates = getCandidates(el, options.includeContainer, isNodeMatchingSelectorTabbable.bind(null, options));
    candidates.forEach(function(candidate, i) {
      var candidateTabindex = getTabindex(candidate);
      if (candidateTabindex === 0) {
        regularTabbables.push(candidate);
      } else {
        orderedTabbables.push({
          documentOrder: i,
          tabIndex: candidateTabindex,
          node: candidate
        });
      }
    });
    var tabbableNodes = orderedTabbables.sort(sortOrderedTabbables).map(function(a) {
      return a.node;
    }).concat(regularTabbables);
    return tabbableNodes;
  };
  var focusableCandidateSelector = /* @__PURE__ */ candidateSelectors.concat("iframe").join(",");
  var isFocusable = function isFocusable2(node, options) {
    options = options || {};
    if (!node) {
      throw new Error("No node provided");
    }
    if (matches.call(node, focusableCandidateSelector) === false) {
      return false;
    }
    return isNodeMatchingSelectorFocusable(options, node);
  };

  // node_modules/focus-trap/dist/focus-trap.esm.js
  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) {
        symbols = symbols.filter(function(sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }
      keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      if (i % 2) {
        ownKeys(Object(source), true).forEach(function(key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function(key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }
    return target;
  }
  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  var activeFocusTraps = function() {
    var trapQueue = [];
    return {
      activateTrap: function activateTrap(trap) {
        if (trapQueue.length > 0) {
          var activeTrap = trapQueue[trapQueue.length - 1];
          if (activeTrap !== trap) {
            activeTrap.pause();
          }
        }
        var trapIndex = trapQueue.indexOf(trap);
        if (trapIndex === -1) {
          trapQueue.push(trap);
        } else {
          trapQueue.splice(trapIndex, 1);
          trapQueue.push(trap);
        }
      },
      deactivateTrap: function deactivateTrap(trap) {
        var trapIndex = trapQueue.indexOf(trap);
        if (trapIndex !== -1) {
          trapQueue.splice(trapIndex, 1);
        }
        if (trapQueue.length > 0) {
          trapQueue[trapQueue.length - 1].unpause();
        }
      }
    };
  }();
  var isSelectableInput = function isSelectableInput2(node) {
    return node.tagName && node.tagName.toLowerCase() === "input" && typeof node.select === "function";
  };
  var isEscapeEvent = function isEscapeEvent2(e) {
    return e.key === "Escape" || e.key === "Esc" || e.keyCode === 27;
  };
  var isTabEvent = function isTabEvent2(e) {
    return e.key === "Tab" || e.keyCode === 9;
  };
  var delay = function delay2(fn) {
    return setTimeout(fn, 0);
  };
  var findIndex = function findIndex2(arr, fn) {
    var idx = -1;
    arr.every(function(value, i) {
      if (fn(value)) {
        idx = i;
        return false;
      }
      return true;
    });
    return idx;
  };
  var valueOrHandler = function valueOrHandler2(value) {
    for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      params[_key - 1] = arguments[_key];
    }
    return typeof value === "function" ? value.apply(void 0, params) : value;
  };
  var getActualTarget = function getActualTarget2(event) {
    return event.target.shadowRoot && typeof event.composedPath === "function" ? event.composedPath()[0] : event.target;
  };

  var createFocusTrap = function createFocusTrap2(elements, userOptions) {
    var doc = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.document) || document;
    var config = _objectSpread2({
      returnFocusOnDeactivate: true,
      escapeDeactivates: true,
      delayInitialFocus: true
    }, userOptions);
    var state = {
      containers: [],
      tabbableGroups: [],
      nodeFocusedBeforeActivation: null,
      mostRecentlyFocusedNode: null,
      active: false,
      paused: false,
      delayInitialFocusTimer: void 0
    };
    var trap;
    var getOption = function getOption2(configOverrideOptions, optionName, configOptionName) {
      return configOverrideOptions && configOverrideOptions[optionName] !== void 0 ? configOverrideOptions[optionName] : config[configOptionName || optionName];
    };
    var containersContain = function containersContain2(element) {
      return !!(element && state.containers.some(function(container) {
        return container.contains(element);
      }));
    };
    var getNodeForOption = function getNodeForOption2(optionName) {
      var optionValue = config[optionName];
      if (typeof optionValue === "function") {
        for (var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          params[_key2 - 1] = arguments[_key2];
        }
        optionValue = optionValue.apply(void 0, params);
      }
      if (!optionValue) {
        if (optionValue === void 0 || optionValue === false) {
          return optionValue;
        }
        throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
      }
      var node = optionValue;
      if (typeof optionValue === "string") {
        node = doc.querySelector(optionValue);
        if (!node) {
          throw new Error("`".concat(optionName, "` as selector refers to no known node"));
        }
      }
      return node;
    };
    var getInitialFocusNode = function getInitialFocusNode2() {
      var node = getNodeForOption("initialFocus");
      if (node === false) {
        return false;
      }
      if (node === void 0) {
        if (containersContain(doc.activeElement)) {
          node = doc.activeElement;
        } else {
          var firstTabbableGroup = state.tabbableGroups[0];
          var firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode;
          node = firstTabbableNode || getNodeForOption("fallbackFocus");
        }
      }
      if (!node) {
        throw new Error("Your focus-trap needs to have at least one focusable element");
      }
      return node;
    };
    var updateTabbableNodes = function updateTabbableNodes2() {
      state.tabbableGroups = state.containers.map(function(container) {
        var tabbableNodes = tabbable(container);
        if (tabbableNodes.length > 0) {
          return {
            container,
            firstTabbableNode: tabbableNodes[0],
            lastTabbableNode: tabbableNodes[tabbableNodes.length - 1]
          };
        }
        return void 0;
      }).filter(function(group) {
        return !!group;
      });
      if (state.tabbableGroups.length <= 0 && !getNodeForOption("fallbackFocus")) {
        throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
      }
    };
    var tryFocus = function tryFocus2(node) {
      if (node === false) {
        return;
      }
      if (node === doc.activeElement) {
        return;
      }
      if (!node || !node.focus) {
        tryFocus2(getInitialFocusNode());
        return;
      }
      node.focus({
        preventScroll: !!config.preventScroll
      });
      state.mostRecentlyFocusedNode = node;
      if (isSelectableInput(node)) {
        node.select();
      }
    };
    var getReturnFocusNode = function getReturnFocusNode2(previousActiveElement) {
      var node = getNodeForOption("setReturnFocus", previousActiveElement);
      return node ? node : node === false ? false : previousActiveElement;
    };
    var checkPointerDown = function checkPointerDown2(e) {
      var target = getActualTarget(e);
      if (containersContain(target)) {
        return;
      }
      if (valueOrHandler(config.clickOutsideDeactivates, e)) {
        trap.deactivate({
          returnFocus: config.returnFocusOnDeactivate && !isFocusable(target)
        });
        return;
      }
      if (valueOrHandler(config.allowOutsideClick, e)) {
        return;
      }
      e.preventDefault();
    };
    var checkFocusIn = function checkFocusIn2(e) {
      var target = getActualTarget(e);
      var targetContained = containersContain(target);
      if (targetContained || target instanceof Document) {
        if (targetContained) {
          state.mostRecentlyFocusedNode = target;
        }
      } else {
        e.stopImmediatePropagation();
        tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
      }
    };
    var checkTab = function checkTab2(e) {
      var target = getActualTarget(e);
      updateTabbableNodes();
      var destinationNode = null;
      if (state.tabbableGroups.length > 0) {
        var containerIndex = findIndex(state.tabbableGroups, function(_ref) {
          var container = _ref.container;
          return container.contains(target);
        });
        if (containerIndex < 0) {
          if (e.shiftKey) {
            destinationNode = state.tabbableGroups[state.tabbableGroups.length - 1].lastTabbableNode;
          } else {
            destinationNode = state.tabbableGroups[0].firstTabbableNode;
          }
        } else if (e.shiftKey) {
          var startOfGroupIndex = findIndex(state.tabbableGroups, function(_ref2) {
            var firstTabbableNode = _ref2.firstTabbableNode;
            return target === firstTabbableNode;
          });
          if (startOfGroupIndex < 0 && state.tabbableGroups[containerIndex].container === target) {
            startOfGroupIndex = containerIndex;
          }
          if (startOfGroupIndex >= 0) {
            var destinationGroupIndex = startOfGroupIndex === 0 ? state.tabbableGroups.length - 1 : startOfGroupIndex - 1;
            var destinationGroup = state.tabbableGroups[destinationGroupIndex];
            destinationNode = destinationGroup.lastTabbableNode;
          }
        } else {
          var lastOfGroupIndex = findIndex(state.tabbableGroups, function(_ref3) {
            var lastTabbableNode = _ref3.lastTabbableNode;
            return target === lastTabbableNode;
          });
          if (lastOfGroupIndex < 0 && state.tabbableGroups[containerIndex].container === target) {
            lastOfGroupIndex = containerIndex;
          }
          if (lastOfGroupIndex >= 0) {
            var _destinationGroupIndex = lastOfGroupIndex === state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1;
            var _destinationGroup = state.tabbableGroups[_destinationGroupIndex];
            destinationNode = _destinationGroup.firstTabbableNode;
          }
        }
      } else {
        destinationNode = getNodeForOption("fallbackFocus");
      }
      if (destinationNode) {
        e.preventDefault();
        tryFocus(destinationNode);
      }
    };
    var checkKey = function checkKey2(e) {
      if (isEscapeEvent(e) && valueOrHandler(config.escapeDeactivates, e) !== false) {
        e.preventDefault();
        trap.deactivate();
        return;
      }
      if (isTabEvent(e)) {
        checkTab(e);
        return;
      }
    };
    var checkClick = function checkClick2(e) {
      if (valueOrHandler(config.clickOutsideDeactivates, e)) {
        return;
      }
      var target = getActualTarget(e);
      if (containersContain(target)) {
        return;
      }
      if (valueOrHandler(config.allowOutsideClick, e)) {
        return;
      }
      e.preventDefault();
      e.stopImmediatePropagation();
    };
    var addListeners = function addListeners2() {
      if (!state.active) {
        return;
      }
      activeFocusTraps.activateTrap(trap);
      state.delayInitialFocusTimer = config.delayInitialFocus ? delay(function() {
        tryFocus(getInitialFocusNode());
      }) : tryFocus(getInitialFocusNode());
      doc.addEventListener("focusin", checkFocusIn, true);
      doc.addEventListener("mousedown", checkPointerDown, {
        capture: true,
        passive: false
      });
      doc.addEventListener("touchstart", checkPointerDown, {
        capture: true,
        passive: false
      });
      doc.addEventListener("click", checkClick, {
        capture: true,
        passive: false
      });
      doc.addEventListener("keydown", checkKey, {
        capture: true,
        passive: false
      });
      return trap;
    };
    var removeListeners = function removeListeners2() {
      if (!state.active) {
        return;
      }
      doc.removeEventListener("focusin", checkFocusIn, true);
      doc.removeEventListener("mousedown", checkPointerDown, true);
      doc.removeEventListener("touchstart", checkPointerDown, true);
      doc.removeEventListener("click", checkClick, true);
      doc.removeEventListener("keydown", checkKey, true);
      return trap;
    };
    trap = {
      activate: function activate(activateOptions) {
        if (state.active) {
          return this;
        }
        var onActivate = getOption(activateOptions, "onActivate");
        var onPostActivate = getOption(activateOptions, "onPostActivate");
        var checkCanFocusTrap = getOption(activateOptions, "checkCanFocusTrap");
        if (!checkCanFocusTrap) {
          updateTabbableNodes();
        }
        state.active = true;
        state.paused = false;
        state.nodeFocusedBeforeActivation = doc.activeElement;
        if (onActivate) {
          onActivate();
        }
        var finishActivation = function finishActivation2() {
          if (checkCanFocusTrap) {
            updateTabbableNodes();
          }
          addListeners();
          if (onPostActivate) {
            onPostActivate();
          }
        };
        if (checkCanFocusTrap) {
          checkCanFocusTrap(state.containers.concat()).then(finishActivation, finishActivation);
          return this;
        }
        finishActivation();
        return this;
      },
      deactivate: function deactivate(deactivateOptions) {
        if (!state.active) {
          return this;
        }
        clearTimeout(state.delayInitialFocusTimer);
        state.delayInitialFocusTimer = void 0;
        removeListeners();
        state.active = false;
        state.paused = false;
        activeFocusTraps.deactivateTrap(trap);
        var onDeactivate = getOption(deactivateOptions, "onDeactivate");
        var onPostDeactivate = getOption(deactivateOptions, "onPostDeactivate");
        var checkCanReturnFocus = getOption(deactivateOptions, "checkCanReturnFocus");
        if (onDeactivate) {
          onDeactivate();
        }
        var returnFocus = getOption(deactivateOptions, "returnFocus", "returnFocusOnDeactivate");
        var finishDeactivation = function finishDeactivation2() {
          delay(function() {
            if (returnFocus) {
              tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
            }
            if (onPostDeactivate) {
              onPostDeactivate();
            }
          });
        };
        if (returnFocus && checkCanReturnFocus) {
          checkCanReturnFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation)).then(finishDeactivation, finishDeactivation);
          return this;
        }
        finishDeactivation();
        return this;
      },
      pause: function pause() {
        if (state.paused || !state.active) {
          return this;
        }
        state.paused = true;
        removeListeners();
        return this;
      },
      unpause: function unpause() {
        if (!state.paused || !state.active) {
          return this;
        }
        state.paused = false;
        updateTabbableNodes();
        addListeners();
        return this;
      },
      updateContainerElements: function updateContainerElements(containerElements) {
        var elementsAsArray = [].concat(containerElements).filter(Boolean);
        state.containers = elementsAsArray.map(function(element) {
          return typeof element === "string" ? doc.querySelector(element) : element;
        });
        if (state.active) {
          updateTabbableNodes();
        }
        return this;
      }
    };
    trap.updateContainerElements(elements);
    return trap;
  };

  var CustomHTMLElement = class extends HTMLElement {
    constructor() {
      super();
      this._hasSectionReloaded = false;
      if (Shopify.designMode) {
        this.rootDelegate.on("shopify:section:select", (event) => {
          const parentSection = this.closest(".shopify-section");
          if (event.target === parentSection && event.detail.load) {
            this._hasSectionReloaded = true;
          }
        });
      }
    }
    get rootDelegate() {
      return this._rootDelegate = this._rootDelegate || new main_default(document.documentElement);
    }
    get delegate() {
      return this._delegate = this._delegate || new main_default(this);
    }
    showLoadingBar() {
      triggerEvent(document.documentElement, "theme:loading:start");
    }
    hideLoadingBar() {
      triggerEvent(document.documentElement, "theme:loading:end");
    }
    untilVisible(intersectionObserverOptions = { rootMargin: "0px", threshold: 0.2 }) {
      const onBecameVisible = () => {
        this.classList.add("became-visible");
        this.style.opacity = "1";
      };
      return new Promise((resolve) => {
        if (window.IntersectionObserver) {
          this.intersectionObserver = new IntersectionObserver((event) => {
            if (event[0].isIntersecting) {
              this.intersectionObserver.disconnect();
              requestAnimationFrame(() => {
                resolve();
                onBecameVisible();
              });
            }
          }, intersectionObserverOptions);
          this.intersectionObserver.observe(this);
        } else {
          resolve();
          onBecameVisible();
        }
      });
    }
    disconnectedCallback() {
      var _a;
      this.delegate.destroy();
      this.rootDelegate.destroy();
      (_a = this.intersectionObserver) == null ? void 0 : _a.disconnect();
      delete this._delegate;
      delete this._rootDelegate;
    }
  };
  var QuickBuySecond = class extends CustomHTMLElement{
    connectedCallback() {
      this.addEventListener('click', (e)=>{
        e.preventDefault();
        e.stopPropagation();
      })  
      let temp_ele = document.createElement('div');
      temp_ele.classList.add('mobile-view-triger');
      temp_ele.innerText = "+";
      this.prepend(temp_ele);
      temp_ele.addEventListener('click',function(){
        if(document.querySelector('quick-buy-second[open]') != this.closest('quick-buy-second')){
          document.querySelector('quick-buy-second[open]')?.toggleAttribute('open'); 
        }               
        this.closest('quick-buy-second').toggleAttribute('open');
      })
      this.querySelectorAll('li.variant-option:not(.sold-out)').forEach((option) => {        
        option.addEventListener("click", (event) => {          
          event.preventDefault();
          event.stopPropagation(); 
          this.closest('quick-buy-second').toggleAttribute('open');         
          let items = [];
          // animation for submitting
          document.dispatchEvent(new CustomEvent('theme:loading:start'));
          event.target.closest('.quick-add-wraper-js')?.setAttribute('aria-busy',true); 
          var custom_properties = {                
                '_source': "collection",
                '_sourceurl': window.location.pathname,
                '_add_type': 'quick_add',
                '_scroll_depth': localStorage.scroll_deapth + "%"
              } 
          if(localStorage.discount_card == 'clicked'){
            custom_properties._discount_card = 'clicked';
          }
          if(localStorage.used_filter != undefined){              
            custom_properties._used_filters = localStorage.used_filter;
          }
          const searchParams = new URLSearchParams(window.location.search);
          searchParams.forEach((val,key)=>{
            switch(key){
              case "internal_referral":
                custom_properties._internal_referrer = val;
                break;
              case "utm_source":
                custom_properties._utm_source = val;
                break;
              case "utm_medium":
                custom_properties._utm_medium = val;
                break;
              case "utm_campaign":
                custom_properties._utm_campaign = val;
                break;
              case "utm_term":
                custom_properties._utm_term = val;
                break;
              case "utm_content":
                custom_properties._utm_content = val;
                break;
              case "campaign_id":
                custom_properties._campaign_id = val;
                break;
              case "ad_id":
                custom_properties._ad_id = val;
                break;
              case "section_clicked":
                custom_properties._section_clicked = val;
                break;
              case "section_source":
                custom_properties._section_source = val;
                break;
              case "_ab_croboost":
                custom_properties._ab_croboost = val;
                break;
            }              
              
          })
          if(event.target.getAttribute('pre_order')){
            custom_properties.pre = 'order'
          }
          items.push(
          { 
            quantity: 1, 
            id: event.target.getAttribute('value'), 
            properties: custom_properties
          });            
        
          // fire event add items to cart
          addQuickItems(items);
        
          // get fresh cart details
          async function getCart() {
            const result = await fetch("/cart.js");
            const res = await result.json();
            return res;
          }
        
          function addQuickItems(items) {

            let sectionsToBundle = [];

            document.documentElement.dispatchEvent(
                new CustomEvent("cart:prepare-bundled-sections", {
                    bubbles: true,
                    detail: { sections: sectionsToBundle }
                })
            );

            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                },
                body: JSON.stringify({
                    items: items,
                    sections: sectionsToBundle,
                    sections_url: window.location.pathname
                })
            })
            .then(res => res.json())
            .then(async (responseJson) => {

                const cartContent = await (await fetch('/cart.js')).json();
                cartContent["sections"] = responseJson["sections"];

                document.dispatchEvent(new CustomEvent('theme:loading:end'));

                document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
                bubbles: true,
                detail: {
                    baseEvent: "variant:add",
                    cart: cartContent
                }
                }));

                document.querySelector('.quick-add-wraper-js[aria-busy]')?.removeAttribute('aria-busy');

            });

          }
        });
      })
    }
    async getPreOrderElement(url){
      await fetch(window.location.origin+`${url}`).then(async (response) => {
        var temp = document.createElement("html");
        temp.innerHTML = await response.text();
        this.querySelector('.pyorderfields-wraper').innerHTML = temp.querySelector('#pyorderfileds').innerHTML;
        this.querySelector('.product-item__quick-buy-button').click();
      });
    }
    
  };
  window.customElements.define("quick-buy-second", QuickBuySecond);

  
  class ZipProtection extends CustomHTMLElement {

    connectedCallback() {    
      
      if (this._initialized) return;
      this._initialized = true;

      const checkbox = this.querySelector('#shippingProtectionCheckBox');
      if (!checkbox) return;

      checkbox.addEventListener("change", async (event) => {

        const checked = checkbox.checked;
        const variantId = checkbox.getAttribute('data-protected-variant');

        if (!variantId) return;
        
        if (this._loading) return;
        this._loading = true;

        try {

          if (!checked) {
            console.log('unchecking and removing protection');

            document.querySelector('.line-item[data-handle*=navidium] [aria-label*=Remove]')?.click();

            this._loading = false;
            return;
          }

          console.log('checked and adding protection');

          // start loading animation
          document.dispatchEvent(new CustomEvent('theme:loading:start'));

          // get current cart
          const cart = await (await fetch('/cart.js')).json();
          
          const exists = cart.items.some(item => item.id == variantId);
          if (exists) {
            console.log('protection already exists');
            document.dispatchEvent(new CustomEvent('theme:loading:end'));
            this._loading = false;
            return;
          }

          let items = [{
            quantity: 1,
            id: variantId,
            properties: {
              '_add_type': 'quick_add'
            }
          }];

          let sectionsToBundle = [];

          document.documentElement.dispatchEvent(
            new CustomEvent("cart:prepare-bundled-sections", {
              bubbles: true,
              detail: { sections: sectionsToBundle }
            })
          );

          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              items: items,
              sections: sectionsToBundle,
              sections_url: window.location.pathname
            })
          });

          const responseJson = await response.json();

          // get updated cart
          const updatedCart = await (await fetch('/cart.js')).json();
          updatedCart["sections"] = responseJson["sections"];

          document.dispatchEvent(new CustomEvent('theme:loading:end'));

          document.documentElement.dispatchEvent(
            new CustomEvent("cart:change", {
              bubbles: true,
              detail: {
                baseEvent: "variant:add",
                cart: updatedCart
              }
            })
          );

          document
            .querySelector('.quick-add-wraper-js[aria-busy]')
            ?.removeAttribute('aria-busy');

        } catch (error) {
          console.error('ZipProtection error:', error);
        }

        this._loading = false;

      });
    }
  }

  window.customElements.define("zip-protection", ZipProtection);  

  document.addEventListener("cart-drawer:refreshed", async () => {
    try {
      const cart = await (await fetch('/cart.js')).json();

      if(document.querySelector('.cart-discount-step-point.step-discount-1.active') && document.querySelector('.discount-gift-item-1.claimed') == null){
        document.querySelector('.discount-gift-item-1 quick-buy-second li[available="true"]')?.click();
      }

      if(localStorage.protected_added != 'true'){
        setTimeout(function(){ 
          localStorage.protected_added = true;
          console.log('a12');
          //document.querySelector('#shippingProtectionCheckBox:not(:checked)')?.click();            
        },200);        
      }          

      /* gift manage event */                 
      if((!document.querySelector('.step-discount-1')?.classList.contains('active') && document.querySelector('.cart-drawer__items .line-item.free-gift-item-1') != null)){
        document.querySelector('.line-item.free-gift-item-1 [aria-label*=Remove]')?.click()
      }
      if((!document.querySelector('.step-discount-2')?.classList.contains('active') && document.querySelector('.cart-drawer__items .line-item.free-gift-item-2') != null)){
        document.querySelector('.line-item.free-gift-item-2 [aria-label*=Remove]')?.click()
      }
      if(!document.querySelector('.step-discount-3')?.classList.contains('active') && document.querySelector('.CartItemWrapper.free-gift-item-3') != null){
        document.querySelector('.line-item.free-gift-item-3 [aria-label*=Remove]')?.click()
      }

      // ✅ condition: only 1 item
      if (cart.item_count !== 1) return;

      const item = cart.items[0];

      // ✅ check handle
      if (item.handle.indexOf("navidium") < 0 ) return;

      console.log("Only protection item in cart → removing...");
      if(document.querySelector('.line-item[data-handle*=navidium] [aria-label*=Remove]')){
        localStorage.protected_added = false;
        document.querySelector('.line-item[data-handle*=navidium] [aria-label*=Remove]')?.click();
      }
      
      

    } catch (e) {
      console.error("Auto-remove protection error:", e);
    }
  });

   

  // js/mixin/loader-button.js
  var LoaderButtonMixin = {
    _prepareButton() {
      this.originalContent = this.innerHTML;
      this._startTransitionPromise = null;
      this.innerHTML = `
      <span class="loader-button__text">${this.innerHTML}</span>
      <span class="loader-button__loader" hidden>
        <div class="spinner">
          <svg focusable="false" width="24" height="24" class="icon icon--spinner" viewBox="25 25 50 50">
            <circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="5"></circle>
          </svg>
        </div>
      </span>
    `;
      this.textElement = this.firstElementChild;
      this.spinnerElement = this.lastElementChild;
      window.addEventListener("pagehide", () => this.removeAttribute("aria-busy"));
    },
    _startTransition() {
      const textAnimation = this.textElement.animate({
        opacity: [1, 0],
        transform: ["translateY(0)", "translateY(-10px)"]
      }, {
        duration: 75,
        easing: "ease",
        fill: "forwards"
      });
      this.spinnerElement.hidden = false;
      const spinnerAnimation = this.spinnerElement.animate({
        opacity: [0, 1],
        transform: ["translate(-50%, 0%)", "translate(-50%, -50%)"]
      }, {
        duration: 75,
        delay: 75,
        easing: "ease",
        fill: "forwards"
      });
      this._startTransitionPromise = Promise.all([
        new Promise((resolve) => textAnimation.onfinish = () => resolve()),
        new Promise((resolve) => spinnerAnimation.onfinish = () => resolve())
      ]);
    },
    async _endTransition() {
      if (!this._startTransitionPromise) {
        return;
      }
      await this._startTransitionPromise;
      this.spinnerElement.animate({
        opacity: [1, 0],
        transform: ["translate(-50%, -50%)", "translate(-50%, -100%)"]
      }, {
        duration: 75,
        delay: 100,
        easing: "ease",
        fill: "forwards"
      }).onfinish = () => this.spinnerElement.hidden = true;
      this.textElement.animate({
        opacity: [0, 1],
        transform: ["translateY(10px)", "translateY(0)"]
      }, {
        duration: 75,
        delay: 175,
        easing: "ease",
        fill: "forwards"
      });
      this._startTransitionPromise = null;
    }
  };

  // js/custom-element/behavior/toggle-button.js
  var ToggleButton = class extends HTMLButtonElement {
    static get observedAttributes() {
      return ["aria-expanded", "aria-busy"];
    }
    constructor() {
      super();
      if (this.hasAttribute("loader")) {
        this._prepareButton();
      }
      this.addEventListener("click", this._onButtonClick.bind(this));
      this.rootDelegate = new main_default(document.documentElement);
    }
    _onButtonClick() {
      this.isExpanded = !this.isExpanded;
    }
    connectedCallback() {
      document.addEventListener("openable-element:close", (event) => {
        if (this.controlledElement === event.target) {
          this.isExpanded = false;
          event.stopPropagation();
        }
      });
      document.addEventListener("openable-element:open", (event) => {
        if (this.controlledElement === event.target) {
          this.isExpanded = true;
          event.stopPropagation();
        }
      });
      this.rootDelegate.on("openable-element:load:start", `#${this.getAttribute("aria-controls")}`, () => {
        if (this.classList.contains("button")) {
          this.setAttribute("aria-busy", "true");
        } else if (this.offsetParent !== null) {
          triggerEvent(document.documentElement, "theme:loading:start");
        }
      }, true);
      this.rootDelegate.on("openable-element:load:end", `#${this.getAttribute("aria-controls")}`, () => {
        if (this.classList.contains("button")) {
          this.removeAttribute("aria-busy");
        } else if (this.offsetParent !== null) {
          triggerEvent(document.documentElement, "theme:loading:end");
        }
      }, true);
    }
    disconnectedCallback() {
      this.rootDelegate.destroy();
    }
    get isExpanded() {
      return this.getAttribute("aria-expanded") === "true";
    }
    set isExpanded(value) {
      this.setAttribute("aria-expanded", value ? "true" : "false");
    }
    get controlledElement() {
      return document.getElementById(this.getAttribute("aria-controls"));
    }
    attributeChangedCallback(name, oldValue, newValue) {
      switch (name) {
        case "aria-expanded":
          if (oldValue === "false" && newValue === "true") {
            this.controlledElement.open = true;
          } else if (oldValue === "true" && newValue === "false") {
            this.controlledElement.open = false;
          }
          break;
        case "aria-busy":
          if (this.hasAttribute("loader")) {
            if (newValue === "true") {
              this._startTransition();
            } else {
              this._endTransition();
            }
          }
          break;
      }
    }
  };  
  Object.assign(ToggleButton.prototype, LoaderButtonMixin);
  window.customElements.define("toggle-button", ToggleButton, { extends: "button" });

  var OpenableElement = class extends CustomHTMLElement {
    static get observedAttributes() {
      return ["open"];
    }
    constructor() {
      super();
      if (Shopify.designMode) {
        this.rootDelegate.on("shopify:section:select", (event) => filterShopifyEvent(event, this, () => this.open = true));
        this.rootDelegate.on("shopify:section:deselect", (event) => filterShopifyEvent(event, this, () => this.open = false));
      }
      if (this.hasAttribute("append-body")) {
        const existingNode = document.getElementById(this.id);
        this.removeAttribute("append-body");
        if (existingNode && existingNode !== this) {
          existingNode.replaceWith(this.cloneNode(true));
          this.remove();
        } else {
          document.body.appendChild(this);
        }
      }
    }
    connectedCallback() {
      this.delegate.on("click", ".openable__overlay", () => this.open = false);
      this.delegate.on("click", '[data-action="close"]', (event) => {
        event.stopPropagation();
        this.open = false;
      });
    }
    get requiresLoading() {
      return this.hasAttribute("href");
    }
    get open() {
      return this.hasAttribute("open");
    }
    set open(value) {
      if (value) {
        (async () => {
          await this._load();
          this.clientWidth;
          this.setAttribute("open", "");
        })();
      } else {
        this.removeAttribute("open");
      }
    }
    get shouldTrapFocus() {
      return true;
    }
    get returnFocusOnDeactivate() {
      return !this.hasAttribute("return-focus") || this.getAttribute("return-focus") === "true";
    }
    get focusTrap() {
      return this._focusTrap = this._focusTrap || createFocusTrap(this, {
        fallbackFocus: this,
        initialFocus: this.hasAttribute("initial-focus-selector") ? this.getAttribute("initial-focus-selector") : void 0,
        clickOutsideDeactivates: (event) => !(event.target.hasAttribute("aria-controls") && event.target.getAttribute("aria-controls") === this.id),
        allowOutsideClick: (event) => event.target.hasAttribute("aria-controls") && event.target.getAttribute("aria-controls") === this.id,
        returnFocusOnDeactivate: this.returnFocusOnDeactivate,
        onDeactivate: () => this.open = false,
        preventScroll: true
      });
    }
    attributeChangedCallback(name, oldValue, newValue) {
      switch (name) {
        case "open":
          if (oldValue === null && newValue === "") {
            if (this.shouldTrapFocus) {
              setTimeout(() => this.focusTrap.activate(), 150);
            }
            triggerEvent(this, "openable-element:open");
          } else if (newValue === null) {
            if (this.shouldTrapFocus) {
              this.focusTrap.deactivate();
            }
            triggerEvent(this, "openable-element:close");
          }
      }
    }
    async _load() {
      if (!this.requiresLoading) {
        return;
      }
      triggerNonBubblingEvent(this, "openable-element:load:start");
      const response = await fetch(this.getAttribute("href"));
      const element = document.createElement("div");
      element.innerHTML = await response.text();
      this.innerHTML = element.querySelector(this.tagName.toLowerCase()).innerHTML;
      this.removeAttribute("href");
      triggerNonBubblingEvent(this, "openable-element:load:end");
    }
  };
  window.customElements.define("openable-element", OpenableElement);

 // js/custom-element/ui/popover.js
  var PopoverContent = class extends OpenableElement {
    connectedCallback() {
      super.connectedCallback();
      this.delegate.on("click", ".popover__overlay,.popover__choice-item", () => this.open = false);      
    }
    attributeChangedCallback(name, oldValue, newValue) {
      super.attributeChangedCallback(name, oldValue, newValue);
      switch (name) {
        case "open":
          document.documentElement.classList.toggle("lock-mobile", this.open);
      }
    }
  };
  window.customElements.define("popover-content", PopoverContent);

  var AddBundle = class extends CustomHTMLElement{
    connectedCallback() {
      //this.querySelector('.add_to_bundle').addEventListener("click", (event) => {
      this.delegate.on("click",'.add_to_bundle', (event) => {
        let items = [];
        // animation for submitting
        document.dispatchEvent(new CustomEvent('theme:loading:start'));
        event.target.setAttribute('aria-busy',true); 
        if(document.querySelector('body').classList.contains('template-style-bundle_c_group')){
          var custom_properties = {                
            '_source': "bundle_add",
            '_sourceurl': window.location.pathname,
            '_add_type': 'quick_add'
          } 
        }else{
          var custom_properties = {                
            '_source': "collection",
            '_sourceurl': window.location.pathname,
            '_add_type': 'quick_add',
            '_scroll_depth': localStorage.scroll_deapth + "%"
          } 
        }
        if(localStorage.discount_card == 'clicked'){
          custom_properties._discount_card = 'clicked';
        }
        if(localStorage.used_filter != undefined){              
          custom_properties._used_filters = localStorage.used_filter;
        }
        const searchParams = new URLSearchParams(window.location.search);
        searchParams.forEach((val,key)=>{
          switch(key){
            case "internal_referral":
              custom_properties._internal_referrer = val;
              break;
            case "utm_source":
              custom_properties._utm_source = val;
              break;
            case "utm_medium":
              custom_properties._utm_medium = val;
              break;
            case "utm_campaign":
              custom_properties._utm_campaign = val;
              break;
            case "utm_term":
              custom_properties._utm_term = val;
              break;
            case "utm_content":
              custom_properties._utm_content = val;
              break;
            case "campaign_id":
              custom_properties._campaign_id = val;
              break;
            case "ad_id":
              custom_properties._ad_id = val;
              break;
            case "section_clicked":
              custom_properties._section_clicked = val;
              break;
            case "section_source":
              custom_properties._section_source = val;
              break;
            case "_ab_croboost":
              custom_properties._ab_croboost = val;
              break;
          }              
            
        })
        if(this.querySelector('.size-wraper button .selected-value>.size-option').getAttribute('pre_order')){
          custom_properties.pre = 'order'
        }
        items.push(
        { 
          quantity: 1, 
          id: this.querySelector('.size-wraper button .selected-value>.size-option').getAttribute('value'), 
          properties: custom_properties
        });            
      
        // fire event add items to cart
        addQuickItems(items);
      
        // get fresh cart details
        async function getCart() {
          const result = await fetch("/cart.json");
          const res = await result.json();
          return res;
        }
      
        function addQuickItems(items) {
          fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ items: items }),
          }).then((v) => {            
            getCart().then(v => {
              document.dispatchEvent(new CustomEvent('theme:loading:end'));
              if(document.querySelector('.bundle-floating-bar-wraper')){
                let floating_item = document.querySelector('.bundle-floating-bar-wraper').getAttribute('data-item')*1 +1;
                document.querySelector('.bundle-floating-bar-wraper').setAttribute('data-item',floating_item);
                if(floating_item>=3){                  
                  document.querySelector('.bundle-floating-bar-wraper .Heading').innerHTML = "You got 30% off";                
                  document.querySelector(".bundle-floating-bar-wraper .shipping-bar__progress").setAttribute('style','--progress:100%'); 
                  document.dispatchEvent(new CustomEvent('product:added', {
                    bubbles: true,
                    detail: {
                      //variant: _this4.currentVariant,
                      quantity: 1
                    }
                  }));
                }else if(floating_item==2){                
                  document.querySelector('.bundle-floating-bar-wraper .Heading').innerHTML = "Add 1 more item to receive 30% off";                
                  document.querySelector(".bundle-floating-bar-wraper .shipping-bar__progress").setAttribute('style','--progress:66.66%');
                  if(document.querySelector('body.bundle-add-step-none')){
                    document.dispatchEvent(new CustomEvent('product:added', {
                      bubbles: true,
                      detail: {                      
                        quantity: 1
                      }
                    }));
                  }else{
                    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                      bubbles: true
                    }));
                  }
                }else if(floating_item==1){                
                  document.querySelector('.bundle-floating-bar-wraper .Heading').innerHTML = "Add 2 more items to receive 30% off";                
                  document.querySelector(".bundle-floating-bar-wraper .shipping-bar__progress").setAttribute('style','--progress:33.33%');
                  if(document.querySelector('body.bundle-add-step-none')){
                    document.dispatchEvent(new CustomEvent('product:added', {
                      bubbles: true,
                      detail: {                      
                        quantity: 1
                      }
                    }));
                  }else{
                    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                      bubbles: true
                    }));
                  }
                }
              }else{                
                document.dispatchEvent(new CustomEvent('product:added', {
                  bubbles: true,
                  detail: {
                    //variant: _this4.currentVariant,
                    quantity: 1
                  }
                }));
              }
              // success
              document.querySelector('#bundle-info-modal .Drawer__Close').click();
              document.querySelector('[aria-busy]')?.removeAttribute('aria-busy');                
            });
          });
        }        
      })  
    }
  };
  window.customElements.define("add-bundle", AddBundle);

var QuickBuyThird = class extends CustomHTMLElement{
    connectedCallback() {
      this.addEventListener('click',function(event){
        if(event.target.classList.contains('size-option') && event.target.classList.contains('popover__choice-item')){
          event.target.closest('.size-wraper').querySelector('.popover-button .selected-value').innerHTML = event.target.outerHTML;
          if(event.target.getAttribute('pre_order-message')){
            this.querySelector('.pre_order-message').innerText = event.target.getAttribute('pre_order-message');
          }else{
            this.querySelector('.pre_order-message').innerText = "";
          }      
        }
        if(event.target.classList.contains('color-option') && event.target.classList.contains('popover__choice-item')){
          event.target.closest('.color_group-wraper').querySelector('.popover-button .selected-value').innerHTML = event.target.outerHTML;
        }
      })
      this.querySelector('.third_add_to_cart')?.addEventListener("click", (event) => {
        
        let items = [];
        // animation for submitting
        document.dispatchEvent(new CustomEvent('theme:loading:start'));
        event.target.setAttribute('aria-busy',true); 
        var custom_properties = {
              '_sourceurl': window.location.pathname,
              '_add_type': 'quick_add',
              '_upsells': 'true',
              '_scroll_depth': localStorage.scroll_deapth + "%"
            } 
        if(this.getAttribute('data-upsell-type')){          
          custom_properties._upsell_type = this.getAttribute('data-upsell-type');            
        }
        if(localStorage.discount_card == 'clicked'){
          custom_properties._discount_card = 'clicked';
        }
        if(localStorage.used_filter != undefined){              
          custom_properties._used_filters = localStorage.used_filter;
        }
        const searchParams = new URLSearchParams(window.location.search);
        searchParams.forEach((val,key)=>{
          switch(key){
            case "internal_referral":
              custom_properties._internal_referrer = val;
              break;
            case "utm_source":
              custom_properties._utm_source = val;
              break;
            case "utm_medium":
              custom_properties._utm_medium = val;
              break;
            case "utm_campaign":
              custom_properties._utm_campaign = val;
              break;
            case "utm_term":
              custom_properties._utm_term = val;
              break;
            case "utm_content":
              custom_properties._utm_content = val;
              break;
            case "campaign_id":
              custom_properties._campaign_id = val;
              break;
            case "ad_id":
              custom_properties._ad_id = val;
              break;
            case "section_clicked":
              custom_properties._section_clicked = val;
              break;
            case "section_source":
              custom_properties._section_source = val;
              break;
            case "_ab_croboost":
              custom_properties._ab_croboost = val;
              break;
          }              
            
        })
        if(this.querySelector('.size-wraper button .selected-value>.size-option').getAttribute('pre_order')){
          custom_properties.pre = 'order'
        }
        items.push(
        { 
          quantity: 1, 
          id: this.querySelector('.size-wraper button .selected-value>.size-option').getAttribute('value'), 
          properties: custom_properties
        });            
      
        // fire event add items to cart
        if(event.target.classList.contains('discount_gift_btn') && document.querySelector('.CartItemWrapper.free-gift-item') != null){
          fetch("/cart/change.js", {
            method: "POST",
            headers: {  "Content-Type": "application/json",  },
            body: JSON.stringify({
            id: document.querySelector('.CartItemWrapper.free-gift-item').getAttribute('data-id'),
            quantity: 0,
            }),
          })
          .then((response) => response.json())
          .then((data) => {
            addQuickItems(items);
          })
          .catch((error) => {          
            console.error(error);
          });          
        }else{
          addQuickItems(items);
        }
        
      
        // get fresh cart details
        async function getCart() {
          const result = await fetch("/cart.json");
          const res = await result.json();
          return res;
        }
      
        function addQuickItems(items) {
          fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ items: items }),
          }).then((v) => {            
            getCart().then(v => {
                document.dispatchEvent(new CustomEvent('theme:loading:end'));
                document.dispatchEvent(new CustomEvent('product:added', {
                  bubbles: true,
                  detail: {
                    //variant: _this4.currentVariant,
                    quantity: 1
                  }
                }));                
               // success
               document.querySelector('[aria-busy]')?.removeAttribute('aria-busy');                
            });
          });
        }        
      })  
    }
  };
  window.customElements.define("quick-buy-third", QuickBuyThird);


  document.addEventListener("click", function (e) {
      const link = e.target.closest(".boost-sd__product-link[href]");

      if (!link) return;

      // Ignore modifier keys
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

      // Stop Boost's delegated click handler
      e.stopImmediatePropagation();

      // Native navigation
      window.location.assign(link.href);
    },
    true // Capture phase
  );
  
/* Hours Collection: main variant picker -> sticky variant picker sync.
   This intentionally does NOT re-render the sticky bar. It only updates the
   matching sticky control when the main product variant picker changes. */
(() => {
  if (window.__hoursMainToStickyVariantSync) return;
  window.__hoursMainToStickyVariantSync = true;

  const syncMainVariantToSticky = (mainControl) => {
    if (!mainControl) return;

    const formId =
      mainControl.getAttribute('form') ||
      mainControl.closest('form')?.id;

    if (!formId) return;

    const stickyPicker = document.querySelector(
      '[data-sticky-variant-picker][data-main-form-id="' +
        CSS.escape(formId) +
        '"]'
    );

    if (!stickyPicker) return;

    const position = mainControl.getAttribute('data-option-position');
    if (!position) return;

    if (mainControl.matches('input[type="radio"]')) {
      const stickyInput = stickyPicker.querySelector(
        'input[data-option-position="' +
          CSS.escape(position) +
          '"][value="' +
          CSS.escape(mainControl.value) +
          '"]'
      );

      if (!stickyInput) return;

      // Only change the sticky control state. Do not click it, because that
      // would proxy the change back to the main picker and can cause a loop.
      stickyInput.checked = true;
      stickyInput.removeAttribute('disabled');
      stickyInput.setAttribute('checked', 'checked');

      // Make sure the other radio in the same option is no longer checked.
      stickyPicker
        .querySelectorAll(
          'input[type="radio"][data-option-position="' +
            CSS.escape(position) +
            '"]'
        )
        .forEach((input) => {
          if (input !== stickyInput) {
            input.checked = false;
            input.removeAttribute('checked');
          }
        });
    }
  };

  document.addEventListener('change', (event) => {
    const mainControl = event.target.closest(
      'form[id^="product-form-main-"] input[data-option-position], ' +
      'input[data-option-position][form^="product-form-main-"], ' +
      'form[id^="product-form-main-"] select[data-option-position], ' +
      'select[data-option-position][form^="product-form-main-"]'
    );

    if (!mainControl) return;

    // Ignore controls inside the sticky picker.
    if (mainControl.closest('[data-sticky-variant-picker]')) return;

    syncMainVariantToSticky(mainControl);
  });
})();
